import { Period } from "../model/Period";
import { useLivePayouts } from "./useLivePayouts";
import { useMemo } from "react";
import { ProductType } from "motty-utils";
import { dateSort } from "../helpers/dateSort";
import { createCountryStatistics, createSellersStatistics } from "../helpers/createStatistics";
const createProductStatistics = (product, payouts = []) => {
    const productPayouts = payouts.filter(p => p.product === product);
    const orderBy = product === ProductType.CreditCard ? ['count', 'amount'] : ['amount', 'count'];
    const topSellers = createSellersStatistics(productPayouts, orderBy);
    const countryStatistics = createCountryStatistics(productPayouts, orderBy);
    return ({
        topSellers: topSellers.slice(0, 5),
        payoutCountries: countryStatistics,
        latestPayouts: productPayouts.sort((p1, p2) => dateSort(p1.timestamp, p2.timestamp)).slice(0, 3)
    });
};
export const useProductStatistics = (product) => {
    const livePayoutsToday = useLivePayouts(Period.Today);
    const livePayoutsWeek = useLivePayouts(Period.Week);
    const livePayoutsMonth = useLivePayouts(Period.Month);
    const livePayoutsByPeriod = useMemo(() => ({
        [Period.Today]: livePayoutsToday,
        [Period.Week]: livePayoutsWeek,
        [Period.Month]: livePayoutsMonth,
    }), [livePayoutsToday, livePayoutsWeek, livePayoutsMonth]);
    return useMemo(() => {
        const productStatistics = {};
        Object.values(Period).forEach(period => productStatistics[period] = createProductStatistics(product, livePayoutsByPeriod[period]));
        return productStatistics;
    }, [product, livePayoutsByPeriod]);
};
